import { ReactElement } from 'react';

const GenericRowWrapper = ({
  renderRow,
  index,
  value = [],
}: {
  renderRow: (value: any, index: number) => ReactElement;
  value: Array<any>;
  index: number;
}) => {
  return renderRow(value, index);
};

export default GenericRowWrapper;
